import React, { ReactComponentElement } from "react";

import styles from "./AssignmentHeader.module.scss";

type Props = {
  onClick: () => void;
  children: {
    name: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
    chevron:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[];
    dueDate:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[];
    progress:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[];
  };
};

export default function AssignmentHeader({
  onClick,
  children: { name, chevron, dueDate, progress }
}: Props) {
  return (
    <div onClick={onClick} className={styles.header}>
      <div className={styles.title}>
        {name}
        {chevron}
      </div>
      <div className={styles.dueDate}>{dueDate}</div>
      <div className={styles.progress}>{progress}</div>
    </div>
  );
}
